import Component from "@base/Component.js";
import aboutContent from "./aboutContent.js";
import GallerySlideshow from "@modules/gallery/components/GallerySlideshow.js";

// Equipment photos ship with the SPA (frontend/public/images/about/equipment/). 13 images.
const EQUIPMENT = Array.from({ length: 13 }, (_, i) => ({
  src: `/images/about/equipment/equipment_${String(i + 1).padStart(3, "0")}.jpg`,
}));

/**
 * Native About page (bilingual) with an equipment grid that opens the fullscreen
 * slideshow. props: { lang }
 */
export default class AboutPage extends Component {
  render() {
    const c = aboutContent[this.props.lang] || aboutContent.en;

    const equipmentGrid = `
      <div class="equipment">
        <div class="equipment__grid">
          ${EQUIPMENT.map(
            (img, i) =>
              `<button class="equipment__item" data-index="${i}" aria-label="Equipment ${i + 1}">
                 <img src="${img.src}" alt="Equipment ${i + 1}" loading="lazy" />
               </button>`
          ).join("")}
        </div>
      </div>`;

    const sections = c.sections
      .map(
        (s) =>
          `<section class="about-section">
             <h3>${Component.escape(s.h)}</h3>
             ${s.body}
           </section>`
      )
      .join("");

    //${s.equipment ? equipmentGrid : ""} after body

    return `
      <article class="about">
        <header class="page-intro">
          <h1 class="page-intro__title">${Component.escape(c.title)}</h1>
          <div class="page-intro__rule"></div>
        </header>
        ${sections}
        <p class="about-closing">${Component.escape(c.closing)}</p>
      </article>`;
  }

  onMounted() {
    this.$$(".equipment__item").forEach((btn) => {
      this.listen(btn, "click", () => {
        new GallerySlideshow({
          images: EQUIPMENT,
          startIndex: Number(btn.getAttribute("data-index")) || 0,
          alt: "Equipment",
        }).mount(document.body);
      });
    });
  }
}
